<template>
    <div>
        <el-dialog
                :close-on-click-modal="false"
                width="800px"
                top="1px"
                :title="title"
                :visible.sync="show">
            <div style="width: 100%; height: 100%;"  v-loading="loading">
                <div class="w100">
                    <el-form  label-width="110px" :model="form" :rules="rules" ref="ruleForm" class="demo-form-inline">
                        <div class="info-content card-shadow">

                                <div class="area-item">
                                    <div class="area-title">基本信息</div>
                                    <div class="cl-f area-content">

                                        <el-col :span="12">
                                            <el-form-item label="服务类型：" prop="serveType">
                                                <el-radio-group v-model="form.serveType">
                                                    <el-radio :label="0">查询类</el-radio>
                                                    <el-radio :label="1">审批类</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="服务名称：" prop="serveName">
                                                <el-input  v-model="form.serveName"  placeholder="请输入服务名称"></el-input>
                                            </el-form-item>
                                        </el-col>

                                        <el-col :span="12">
                                            <el-form-item label="服务图标：" class="img-form" prop="serveCover">
                                                <div >
                                                    <el-upload
                                                            v-show="!serveImgList.length"
                                                            class="upload-demo"
                                                            action="#"
                                                            accept="image/jpeg,image/png"
                                                            :show-file-list="false"
                                                            :before-upload="serveImgBeforeUpload">
                                                        <el-button slot="trigger">
                                                            <i class="el-icon-upload"></i>
                                                        </el-button>
                                                    </el-upload>


                                                    <div v-if="serveImgList.length">
                                                        <el-image
                                                                class="card-shadow img-warp"
                                                                :src="serveImgList[0].url"
                                                                fit="contain"></el-image>
                                                        <span @click="onRemoveImg(serveImgList[0],'serveImgList')">
                                                         <i class="el-icon-delete"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </el-form-item>
                                            <div style="padding-left: 28px;"  v-show="!serveImgList.length" class="el-upload-tip">
                                                图片大小不超过1M，格式要求JPG、PNG。
                                            </div>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="服务描述：">
                                                <el-input type="textarea" v-model="form.intro"></el-input>
                                            </el-form-item>
                                        </el-col>

                                        <el-col :span="12">
                                            <el-form-item label="办理时效(h)：" class="cl-f">
                                                <el-input type="number" v-model="form.periordValidateHours"  placeholder="请输入办理时效" ></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="可用平台：" prop="plateform">
                                                <el-checkbox-group v-model="form.plateform" @change="plateChange">
                                                    <el-checkbox label="1" >PC平台</el-checkbox>
                                                    <el-checkbox label="2" >移动平台</el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>
                                        </el-col>

                                        <el-col :span="12" v-if="form.plateform.filter(i=>i == '1') && form.serveType == 0">
                                            <el-form-item prop="queryPcUrl"   label="pc端链接：" >
                                                <el-input  v-model="form.queryPcUrl"  placeholder="请输入鏈接地址"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12" v-if="form.plateform.filter(i=>i == '2') && form.serveType == 0">
                                            <el-form-item  prop="queryMobileUrl"  label="移动端链接：" >
                                                <el-input  v-model="form.queryMobileUrl"  placeholder="请输入鏈接地址"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="服务角色：" prop="roleList" >
                                                <el-select v-model="roleSelect" multiple placeholder="请选择服务对象" class="w100">
                                                    <el-option
                                                            v-for="item in roleList"
                                                            :key="item.roleId"
                                                            :label="item.roleName"
                                                            :value="item.roleId">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="归属部门：" prop="belongDeptId">
                                                <TreeSelect size="small"
                                                            :data="departmentData"
                                                            clearable
                                                            v-if="show"
                                                            expandAll
                                                            ref="deptSingle"
                                                            :obj="mapKey"
                                                            checkStrictly
                                                            @getValue="setDeptSingleMenu">
                                                </TreeSelect>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12" v-if="form.serveType == '0'">
                                            <el-form-item label="查询类型：" prop="queryType" >
                                                <el-select v-model="form.queryType" placeholder="请选择查询类型" class="w100">
                                                    <el-option  label="流程" :value="1"></el-option>
                                                    <el-option label="普通" :value="2"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="是否推荐：" >
                                                <el-radio-group v-model="form.recommend">
                                                    <el-radio :label="1">是</el-radio>
                                                    <el-radio :label="0">否</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                        </el-col>
                                        
                                        <el-col>
                                            <el-form-item label="是否热门：">
                                            <el-radio-group v-model="form.hostFlag">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="0">否</el-radio>
                                            </el-radio-group>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12" v-if="form.serveType == '1'">
                                            <el-form-item label="启动规则：" prop="startRule" >
                                                <el-select v-model="form.startRule" placeholder="请选择启动规则" class="w100">
                                                    <el-option
                                                            v-for="item in startRuleList"
                                                            :key="item.value"
                                                            :label="item.label"
                                                            :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                    </div>

                                </div>
                                <div class="area-item" v-if="form.serveType == '1' ">
                                    <div class="area-title">流程信息</div>
                                    <div class="cl-f area-content">
                                        <el-col :span="12">
                                            <el-form-item label="流程ID：" prop="processDefId" :rules="form.serveType == '1' ? rules.processDefId:[{required: false}]">
                                                <el-input placeholder="请输入流程ID"  v-model="form.processDefId"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="流程版本：" prop="processVersionId"  :rules="form.serveType == '1' ? rules.processVersionId:[{required: false}]">
                                                <el-input placeholder="请输入流程版本"  v-model="form.processVersionId"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="联系人：" prop="contact"  :rules="form.serveType == '1' ? rules.contact:[{required: false}]">
                                                <el-input v-model="form.contact" placeholder="请输入联系人" ></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <!--<el-col :span="12">-->
                                            <!--<el-form-item label="负责人：" prop="checkPersons"  :rules="form.serveType == '1' ? rules.checkPersons:[{required: false}]">-->
                                                <!--<el-input-->
                                                        <!--placeholder="请选择负责人"-->
                                                        <!--style="width: 182px"-->
                                                        <!--v-model="userText"-->
                                                        <!--disabled-->
                                                <!--&gt;</el-input>-->
                                                <!--<el-button type="primary" style="margin-left:10px" @click="addUser">+添加</el-button>-->
                                                <!--<by-page-select-->
                                                        <!--ref="pageSelect"-->
                                                        <!--title="人员选择"-->
                                                        <!--:leftData="userList"-->
                                                        <!--v-if="show"-->
                                                        <!--:total="serveTotal"-->
                                                        <!--selectWidth="width: 100%"-->
                                                        <!--collapseTags-->
                                                        <!--:paramSearch="serveParamSearch"-->
                                                        <!--@handleCurrentChange="handleCurrentChange"-->
                                                        <!--@handleSizeChange="handleSizeChange"-->
                                                        <!--@setValue="setValue"-->
                                                <!--&gt;-->
                                                <!--</by-page-select>-->

                                            <!--</el-form-item>-->
                                        <!--</el-col>-->
                                        <!--<el-col :span="12">-->
                                            <!--<el-form-item label="联系方式：" prop="contactMobile"  :rules="form.serveType == '1' ? rules.contactMobile:[{required: false}]">-->
                                                <!--<el-input v-model="form.contactMobile" placeholder="请输入联系方式"></el-input>-->
                                            <!--</el-form-item>-->
                                        <!--</el-col>-->

                                        <el-col :span="12">
                                            <el-form-item label="监管部门：" prop="watchDeptId"  :rules="form.serveType == '1' ? rules.watchDeptId:[{required: false}]">
                                                <TreeSelect size="small"
                                                            :data="departmentData"
                                                            clearable
                                                            v-if="show"
                                                            expandAll
                                                            ref="deptSingleTwo"
                                                            :obj="mapKey"
                                                            checkStrictly
                                                            @getValue="setDeptSingleMenuTwo">

                                                </TreeSelect>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="流程图：" class="img-form" prop="processImg"  :rules="form.serveType == '1' ? rules.processImg:[{required: false}]">
                                                <div>
                                                    <el-upload
                                                            v-show="!processImgList.length"
                                                            class="upload-demo"
                                                            action="#"
                                                            accept="image/jpeg,image/png"
                                                            :show-file-list="false"
                                                            :before-upload="processImgBeforeUpload"
                                                            >
                                                        <el-button slot="trigger">
                                                            <i class="el-icon-upload"></i>
                                                        </el-button>
                                                    </el-upload>
                                                    <div v-if="processImgList.length">
                                                        <el-image
                                                                class="card-shadow img-warp"
                                                                :src="processImgList[0].url"
                                                                fit="contain"></el-image>
                                                        <span @click="onRemoveImg(processImgList[0],'processImgList')">
                                                         <i class="el-icon-delete"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </el-form-item>
                                            <div style="padding-left: 40px;" v-show="!processImgList.length" class="el-upload-tip">
                                                图片大小不超过1M，格式要求JPG、PNG。
                                            </div>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="申请方式：" prop="applyType"  :rules="form.serveType == '1' ? rules.serveType:[{required: false}]">
                                                <el-select v-model="form.applyType" placeholder="请选择申请方式" class="w100">
                                                    <el-option
                                                            v-for="item in applyTypeList"
                                                            :key="item.value"
                                                            :label="item.name"
                                                            :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="申请条件：" prop="applyCondition"  :rules="form.serveType == '1' ? rules.applyCondition:[{required: false}]">
                                                <el-input v-model="form.applyCondition" type="textarea" placeholder="请输入申请条件"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </div>
                                </div>


                                <div class="area-item"  v-if="form.serveType == '1' ">
                                    <div class="area-title">线上办理补充信息</div>
                                    <div class="cl-f area-content">
                                    <el-col :span="12">
                                        <el-form-item label="线上办理时间：">
                                            <el-input  v-model="form.onlineDesc.handleTime" placeholder="请输入线上办理时间"></el-input>

                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="收费方式：">
                                            <el-select v-model="form.onlineDesc.feeWay" placeholder="请选择收费方式" class="w100">
                                                <el-option
                                                        v-for="item in feeWayList"
                                                        :key="item.value"
                                                        :label="item.name"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="办理材料：" class="img-form">
                                            <div >
                                                <el-upload

                                                        class="upload-demo"
                                                        action="#"
                                                        :file-list="onlineDescImgList"
                                                        :before-remove="beforeRemoveOn"
                                                        :on-preview="onPreviewFn"
                                                        :before-upload="onlineDescImgBeforeUpload"
                                                        >
                                                    <el-button  v-if="onlineDescImgList.length<5" slot="trigger">
                                                        <i class="el-icon-upload"></i>
                                                    </el-button>

                                                </el-upload>

                                            </div>
                                        </el-form-item>

                                    </el-col>
                                        <div style="padding-left: 28px;" class="el-upload-tip">
                                            文件不超过4M，支持DOC、DOCX、PDF格式
                                        </div>
                                    <el-col :span="24">
                                        <el-form-item label="办理材料描述：">
                                            <el-input type="textarea"  v-model="form.onlineDesc.handleDesc" placeholder="请输入描述"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </div>
                                </div>
                                <div class="area-item"  v-if="form.serveType == '1' ">
                                    <div class="area-title">线下办理补充信息</div>
                                    <div class="cl-f area-content">
                                        <el-col :span="12">
                                            <el-form-item label="线下办理时间：">
                                                <el-input  v-model="form.offlineDesc.handleTime" placeholder="请输入线下办理时间"></el-input>
                                                <!--<el-date-picker-->
                                                        <!--v-model="form.offlineDesc.handleTime"-->
                                                        <!--type="daterange"-->
                                                        <!--range-separator="至"-->
                                                        <!--start-placeholder="开始日期"-->
                                                        <!--end-placeholder="结束日期">-->
                                                <!--</el-date-picker>-->
                                            </el-form-item>
                                        </el-col>

                                        <el-col :span="12">
                                            <el-form-item label="收费方式：">
                                                <el-select v-model="form.offlineDesc.feeWay" placeholder="请选择收费方式" class="w100">
                                                    <el-option
                                                            v-for="item in feeWayList"
                                                            :key="item.value"
                                                            :label="item.name"
                                                            :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="办理地点：">
                                                <el-input type=""  v-model="form.offlineDesc.place" placeholder="请输入办理地点"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="办理材料：" class="img-form">
                                                <div >

                                                    <el-upload

                                                            class="upload-demo"
                                                            action="#"
                                                            :file-list="offlineDescImgList"
                                                            :on-preview="onPreviewFn"
                                                            :before-remove="beforeRemoveOff"
                                                            :before-upload="offlineDescImgBeforeUpload"
                                                          >
                                                        <el-button  v-if="offlineDescImgList.length<5"  slot="trigger">
                                                            <i class="el-icon-upload"></i>
                                                        </el-button>
                                                    </el-upload>

                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <div style="padding-left: 28px;" class="el-upload-tip">
                                            文件不超过4M，支持DOC、DOCX、PDF格式
                                        </div>
                                        <el-col :span="24">
                                            <el-form-item label="办理材料描述：">
                                                <el-input type="textarea"  v-model="form.offlineDesc.handleDesc" placeholder="请输入描述"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="办理说明：">
                                                <el-input type="textarea"  v-model="form.offlineDesc.handleDegist" placeholder="请输入办理说明"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </div>
                                </div>
                                <div class="area-item">
                                    <div class="area-title">其他信息</div>
                                    <div class="cl-f area-content">
                                        <el-col :span="24">
                                            <el-form-item label="设定依据：">
                                                <div>
                                                    <i class="el-icon-circle-plus" style="cursor: pointer;color: #409EFF"
                                                       @click="addPolicyFn"></i>
                                                    <div class="pt5 pb5 cl-f policy-list" v-for="(item,index) in (form.policy||[])">
                                                        <div class="cl-f pt5 pb5">
                                                        <span class="fl" style="color: #ccc">{{(index+1)+"、"}}</span>
                                                        <span class="fl" style="font-size: 12px;color: #ccc">依据名称</span>
                                                        <el-input v-model="item.name"  class="fl w30 ml10 mr10" placeholder="请输入依据名称"></el-input>
                                                        <span class="fl" style="font-size: 12px;color: #ccc">法规类型</span>
                                                            <el-select v-model="item.type"  class="fl w40 ml10">
                                                                <el-option
                                                                        v-for="pro in policyType"
                                                                        :key="pro.value"
                                                                        :label="pro.name"
                                                                        :value="pro.value">
                                                                </el-option>
                                                            </el-select>
                                                        <i class="el-icon-remove-outline fl mt5 ml5"
                                                           style="cursor: pointer;color: #409EFF"
                                                           @click="delPolicy(index)"></i>
                                                        </div>
                                                        <div class="cl-f pt5 pb5">
                                                            <span class="fl" style="font-size: 12px;color: #ccc">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;条例</span>
                                                            <el-input v-model="item.rules"  class="fl ml10 mr10" style="width: 80.5%;" placeholder="请输入条例"></el-input>
                                                        </div>
                                                        <div class="cl-f pt5 pb5">
                                                            <span class="fl" style="font-size: 12px;color: #ccc">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;条款内容</span>
                                                            <quillEditorCom v-model="item.content" class="fl"   style="width: 82%;padding-left: 10px"/>

                                                        </div>
                                                    </div>

                                                </div>
                                            </el-form-item>
                                        </el-col>

                                    <el-col :span="24">
                                        <el-form-item label="注意事项：">
                                            <el-input type="textarea" v-model="form.attention" placeholder="请输入注意事项"></el-input>
                                        </el-form-item>
                                    </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="常见问题：">
                                                <div>
                                                        <i class="el-icon-circle-plus" style="cursor: pointer;color: #409EFF"
                                                           @click="addProblemFn"></i>
                                                    <div class="pt5 pb5 cl-f" v-for="(item,index) in form.qaList">
                                                        <span class="fl" style="color: #ccc">{{(index+1)+"、"}}</span>
                                                        <span class="fl" style="font-size: 12px;color: #ccc">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;问题</span>
                                                        <el-input v-model="item.question"  class="fl w30 ml10 mr10" placeholder="请输入问题"></el-input>
                                                        <span class="fl" style="font-size: 12px;color: #ccc">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;答案</span>
                                                        <el-input v-model="item.answer" class="fl w40 ml10" placeholder="请输入答案"></el-input>
                                                        <i class="el-icon-remove-outline fl mt5 ml5"
                                                           style="cursor: pointer;color: #409EFF"
                                                        @click="delAsk(index)"></i>

                                                    </div>

                                                </div>
                                            </el-form-item>
                                        </el-col>

                                </div>

                                </div>
                        </div>
                    </el-form>

                </div>

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="submitForm('ruleForm')" type="primary">提 交</el-button>
                <el-button @click="close">取 消</el-button>
            </div>

        </el-dialog>
        <charge-person
                ref="personModal"
                :personData="personData"
                @closePerson="closePerson"
        />
        <cropperImg ref="cropperImg" :autoCropWidth="200" :autoCropHeight="200" @uploadHttp="uploadHttp"/>
        <select-serve ref="selectServeRef" @sureSelect="sureSelect"/>
    </div>
</template>

<script>
    import SelectServe from "@/components/SelectServe.vue";
    import TreeSelect from "@/components/TreeSelect.vue";
    import  chargePerson from "@/components/management/reportManage/chargePerson.vue";
    import { hallSaveOrUpdate} from '@/api/managementCenter/serveManage';
    import { getRoleList,getDeptTree,getUserPageTwo} from '@/api/managementCenter/otherApi';
    import { serveFileUpload,serveFileDelete} from '@/api/managementCenter/otherApi';
    import cropperImg from '@/components/common/cropperImg.vue'
    import quillEditorCom from '@/components/common/quillEditor.vue'
    import request from '@/util/http'
    export default {
        name: "ServeDialog",
        components: {
            SelectServe,
            chargePerson,
            TreeSelect,
            cropperImg,
            quillEditorCom
        },
        props: [],
        data() {
            return {
                problemList:[],
                userList:[],
                serveParamSearch:{
                    current:1,
                    size:10,
                },
                serveTotal:0,
                type:'',
                plateData: [
                    {
                        value: '1',
                        name: 'PC平台'
                    },
                    {
                        value: '2',
                        name: '移动平台'
                    }
                ],
                serveTypeList:[
                    {
                        name:'请选择',
                        value:''
                    },
                    {
                        name:'查询类',
                        value:'0'
                    },
                    {
                        name:'审批类',
                        value:'1'
                    }
                ],
                applyTypeList:[
                    {
                        name:'请选择',
                        value:''
                    },
                    {
                        name:'线上',
                        value:'1'
                    },
                    {
                        name:'线下',
                        value:'2'
                    },
                    {
                        name:'线上和线下',
                        value:'3'
                    }
                ],
                feeWayList:[
                    {
                        name:'请选择',
                        value:''
                    },
                    {
                        name:'免费',
                        value:'免费'
                    },
                    {
                        name:'收费',
                        value:'收费'
                    }
                ],
                onlineTime:[
                    {
                        name:'请选择',
                        value:''
                    },
                    {
                        name:'半天',
                        value:'半天'
                    },
                    {
                        name:'全天',
                        value:'全天'
                    }
                ],
                policyType:[
                    {
                        name:'请选择',
                        value:''
                    },
                    {
                        name:'国家法规',
                        value:'1'
                    },
                    {
                        name:'地方法规',
                        value:'2'
                    },
                    {
                        name:'行政法规',
                        value:'3'
                    },
                    {
                        name:'学校政策',
                        value:'4'
                    },
                    {
                        name:'部门规章',
                        value:'5'
                    },
                    {
                        name:'其他',
                        value:'6'
                    }
                ],
                roleSelect:[],
                roleList:[],
                departmentData:[],
                mapKey:{
                    id:'id',// ID
                    label: 'name',// 显示名称
                    children: 'children', //子级字段名
                },
                imgSrc:'',
                fileList: [],

                serveList:[],
                show: false,
                loading: false,
                title: "",
                serveImgList:[],
                processImgList:[],
                onlineDescImgList:[],
                offlineDescImgList:[],
                startRuleList:[
                    {
                        value:'0',
                        label:'只允许发起一次'
                    },
                    {
                        value:'1',
                        label:'仅能存在一条运行实例'
                    },
                    {
                        value:'2',
                        label:'不限制'
                    }
                ],
                form: {
                    recommend:0,
                    applyCondition: "",
                    applyType: "",
                    attention: "",
                    plateform: [],
                    belongDeptId: "",
                    serveCover :"",
                    checkPersons: "",
                    contact: "",
                    startRule:'',
                    contactMobile: "",
                    fileList: [
                        {
                            fileId: "",
                            fileType: ""
                        }
                    ],
                    id: "",
                    intro: "",
                    offlineDesc: {
                        handleTime:'',
                        handleDesc :'',
                        place:'',
                        feeWay :'',
                        handleDegist :'',
                    },
                    onlineDesc: {
                        handleTime:'',
                        handleDesc :'',
                        feeWay :'',

                    },
                    offlineDescImg:'',
                    onlineDescImg:'',
                    processDefId: "",
                    processImg:'',
                    processVersionId: "",
                    qaList: [

                    ],
                    roleList: [
                    ],
                    policy:[],
                    serveName: "",
                    periordValidateHours:'',
                    serveType: 0,
                    watchDeptId: "",
                    queryType:'',
                    hostFlag: "0",
                },
                personData: {
                    userData: [],
                    state: false,
                    disabled: false,
                    data: null,
                    type:'radio'
                },
                userText:'',
                userId:[],
                rules: {
                    serveName: [
                        { required: true, message: "请输入服务名称", trigger: "blur" }
                    ],
                    serveType: [
                        { required: true, message: "请选择服务类型", trigger: "change" }
                    ],
                    queryType: [
                        { required: true, message: "请选择查询类型", trigger: "change" }
                    ],
                    startRule: [
                        { required: true, message: "请选择启动规则", trigger: "change" }
                    ],
                    serveCover: [
                        { required: true, message: "请上传服务图片", trigger: "blur" }
                    ],
                    processDefId: [
                        { required: true, message: "请输入流程ID", trigger: "blur" }
                    ],
                    processVersionId: [
                        { required: true, message: "请输入流程版本", trigger: "blur" }
                    ],
                    plateform: [
                        {type: 'array',  required: true, message: "请选择可用平台", trigger: "change" }
                    ],
                    processImg: [
                        { required: true, message: "请上传流程图片", trigger: "blur" }
                    ],
                    roleList: [
                        { required: true, message: "请选择服务角色对象", trigger: "change" }
                    ],
                    contactMobile: [
                        { required: true, message: "请输入联系方式", trigger: "blur" }
                    ],
                    contact: [
                        { required: true, message: "请输入联系人", trigger: "blur" }
                    ],
                    checkPersons: [
                        { required: true, message: "请选择负责人", trigger: "blur" }
                    ],
                    belongDeptId: [
                        { required: true, message: "请选择归属部门", trigger: "change" }
                    ],
                    watchDeptId: [
                        { required: true, message: "请选择监管部门", trigger: "change" }
                    ],
                    applyType: [
                        { required: true, message: "请选择申请方式", trigger: "change" }
                    ],
                    applyCondition: [
                        { required: true, message: "请输入申请条件", trigger: "blur" }
                    ],
                    queryPcUrl: [
                        { required: false, message: "请输入pc端链接地址", trigger: "blur" }
                    ],
                    queryMobileUrl: [
                        { required: false, message: "请输入移动端链接地址", trigger: "blur" }
                    ],
                }
            };
        },
        computed: {

        },
        mounted(){
        },
        methods: {
            handleCurrentChange(value) {
                this.serveParamSearch.current = value;
                this.getUserPage();
            },
            handleSizeChange(value) {
                this.serveParamSearch.size = value;
                this.serveParamSearch.current = 1;
                this.getUserPage();
            },

            // setValue(data) {
            //     this.form.checkPersons=data
            //
            // },

            onRemoveImg(file,key){
                if(!file.id){
                    return;
                }
                this.deleteFile(file.id,()=>{
                        this[key] = []
                })

            },
            beforeRemoveOn(file) {
                if(!file.id){
                    return;
                }
                this.deleteFile(file.id,()=>{
                    this.onlineDescImgList =this.onlineDescImgList.filter(i=>{
                        return file.id!=i.id
                    })


                })
            },
            beforeRemoveOff(file) {
                if(!file.id){
                    return;
                }
                this.deleteFile(file.id,()=>{
                    this.offlineDescImgList =this.offlineDescImgList.filter(i=>{
                        return file.id!=i.id
                    })
                })
            },
            onPreviewFn(file){
                window.open(file.fileUrl);

            },
            deleteFile(id,callBack){
                serveFileDelete(id).then(({data}) => {
                    if(data.code == 0){
                        callBack&&callBack()
                        this.$message.success(  "删除成功!" );
                    }else{
                        this.$message.warning( data.msg||"删除失败！" );
                    }
                }).catch(err=>{
                    this.$message.error( "删除异常!" );
                })
            },
            serveImgBeforeUpload(file){
                this.handleBeforeUpload(file,'0','serveImgList');
            },
            processImgBeforeUpload(file){
                this.handleBeforeUpload(file,'1','processImgList');
            },
            onlineDescImgBeforeUpload(file){
                this.handleBeforeUpload(file,'3','onlineDescImgList');
            },
            offlineDescImgBeforeUpload(file){
                this.handleBeforeUpload(file,'4','offlineDescImgList');
            },
            setDeptSingleMenu(key,data){//获取子组件值
                this.form.belongDeptId = data.id;
            },
            setDeptSingleMenuTwo(key,data){//获取子组件值
                this.form.watchDeptId = data.id;
            },
            getUserPage(){
                getUserPageTwo(this.serveParamSearch).then(({data})=> {
                    if(data.code == 0){
                        this.userList = (data.data.records || []).map(i=>{
                            return {
                                name:i.username,
                                value:i.userId+''
                            }
                        })
                        this.serveTotal = data.data.total;
                    }
                })

            },

            getDeptTreeData(){
                getDeptTree().then(({data})=>{
                    if(data.code == 0){

                        if(data.data&&data.data.length>0) {
                            if(data.data[0].id==1){
                                this.departmentData = data.data[0].children;
                            }else{
                                this.departmentData = data.data
                            }
                        }
                        if( this.type=='edit'){
                            this.$nextTick(()=>{
                                // 编辑时部门回显
                                this.$refs.deptSingle.setKey(this.form.belongDeptId)
                                if(this.form.serveType == '1' ){
                                    this.$refs.deptSingleTwo.setKey(this.form.watchDeptId)

                                }
                            })
                        }

                    }
                }).catch(err=>{

                })

            },
            getRoleListData(){
                getRoleList().then(({data})=>{
                    if(data.code == 0){
                        this.roleList = data.data.map(i=>{
                            return {
                                ...i,
                                roleId:i.roleId+''
                            }
                        })
                    }
                }).catch(err=>{

                })

            },
            addPolicyFn(){
                this.form.policy.push({
                        name:'',
                        type:'',
                        rules:'',
                        content:''
                });
            },
            delPolicy(index){
                this.form.policy.splice(index ,1);
            },
            addProblemFn(){
                this.form.qaList.push({question:'',answer:''});
            },
            delAsk(index){
                this.form.qaList.splice(index ,1);
            },

            uploadHttp(file){
                let type='0';
                let key= 'serveImgList';
                let fd = new FormData();
                fd.append('file',file);
                //上传到后台
                this.loading=true
                serveFileUpload(fd).then(({data}) => {
                    this.loading=false
                    if(data.code == 0) {
                        this.$refs.cropperImg.closeDialog();
                        this.$message.success(  "上传文件成功!" );
                        this[key].push(
                            {
                                ...data.data,
                                fileType:type,
                                fileId:data.data.id,
                                fileUrl:data.data.url,
                                name:data.data.relatedFileName
                            }
                        )
                    }else{
                        this.$message.warning(  data.msg||"上传文件失败!" );
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error(  "上传文件异常!" );
                });

            },
            // 上传文件之前的方法
            handleBeforeUpload(file,type,key){
                if(type!=0){
                    const isLt4M = file.size / 1024 / 1024 < 4;
                    if (!isLt4M) {
                        this.$message.error('上传文件大小不能超过 4MB!');
                        return isLt4M
                    }
                }else{
                    this.$refs.cropperImg.uploadImg(file);
                    return;
                }


                let fd = new FormData();
                fd.append('file',file);
                //上传到后台
                this.loading=true
                serveFileUpload(fd).then(({data}) => {
                    this.loading=false
                    if(data.code == 0) {
                        this.$message.success(  "上传文件成功!" );
                        this[key].push(
                            {
                                ...data.data,
                                fileType:type,
                                fileId:data.data.id,
                                fileUrl:data.data.url,
                                name:data.data.relatedFileName
                            }
                        )
                    }else{
                        this.$message.warning(  data.msg||"上传文件失败!" );
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error(  "上传文件异常!" );
                });
            },
            handlePreview(){
                window.location.href=this.fileList[0].url
            },


            sureSelect(data){
                this.serveList = data
            },

            serveSelect(){
                this.$refs.selectServeRef.openDialog(this.serveList)
            },
            handleClose(tag){
                this.serveList =this.serveList.filter(item=>{
                    return item.serve_id!=tag.serve_id
                })
            },




            // 显示弹框
            dialogShow (type,data) {
                // 重置表单、显示弹框
                this.show = true;


                this.$nextTick(function(){
                    this.serveImgList=[];
                    this.processImgList=[];
                    this.offlineDescImgList=[];
                    this.onlineDescImgList=[];
                    this.roleSelect =[];
                    this.userText='';
                    this.type=type
                    switch (type) {
                        case 'add' :
                            this.fileList=[];
                            this.title = "新增服务"
                            this.form={
                                recommend:0,
                                applyCondition: "",
                                applyType: "",
                                attention: "",
                                plateform: [],
                                belongDeptId: "",
                                checkPersons: "",
                                serveCover:'',
                                contact: "",
                                contactMobile: "",
                                startRule:'',
                                fileList: [],
                                id: "",
                                intro: "",
                                offlineDesc: {
                                    handleTime:'',
                                    handleDesc :'',
                                    feeWay :'',
                                    place:'',
                                    handleDegist :'',
                                },
                                onlineDesc: {
                                    handleTime:'',
                                    handleDesc :'',
                                    feeWay :'',

                                },
                                offlineDescImg:'',
                                onlineDescImg:'',
                                processDefId: "",
                                processImg:'',
                                processVersionId: "",
                                policy:[],
                                qaList: [
                                    {
                                        answer: "",
                                        id: "",
                                        question: "",
                                    }
                                ],
                                roleList: [
                                    {
                                        roleId: "",
                                    }
                                ],
                                serveName: '',
                                periordValidateHours : '',
                                serveType: 0,
                                watchDeptId: '',
                                queryPcUrl: '',
                                queryMobileUrl: '',
                                queryType:'',
                                hostFlag: "0",
                            };
                            break;
                        case 'edit' :
                            this.title = "编辑服务"
                            let offlineDesc={
                                handleTime:'',
                                handleDesc :'',
                                feeWay :'',
                                place:'',
                                handleDegist :''
                               };
                            let onlineDesc = {
                                handleTime:'',
                                handleDesc :'',
                                feeWay :''
                            };
                            if(data.offlineDesc){
                                let offlineDescParse = JSON.parse(data.offlineDesc);
                                if(!offlineDescParse.hasOwnProperty('place')){
                                    offlineDescParse.place=""
                                }
                                offlineDesc = offlineDescParse;
                            }
                            if(data.onlineDesc){
                                onlineDesc = JSON.parse(data.onlineDesc)
                            }
                            let policy;
                            if(data.policy){
                                try{
                                    policy=JSON.parse(data.policy);
                                }catch (e) {
                                    policy=[];
                                }
                            }else{
                                policy=[];
                            }
                            this.form={
                                recommend:data.recommend?Number(data.recommend):0,
                                applyCondition: data.applyCondition,
                                applyType: data.applyType,
                                attention: data.attention,
                                belongDeptId: (data.belongDept || {}).id || '',
                                checkPersons: (data.checkUser || {}).userId || '',
                                contact: data.contact,
                                startRule: data.startRule,
                                contactMobile: data.contactMobile,
                                serveCover:'',
                                fileList:[],
                                id: data.id,
                                intro: data.intro,
                                offlineDesc: offlineDesc,
                                onlineDesc: onlineDesc,
                                offlineDescImg:'',
                                onlineDescImg:'',
                                plateform: (data.plateform).split(','),
                                queryPcUrl: data.queryPcUrl,
                                queryMobileUrl: data.queryMobileUrl,
                                policy:policy,
                                processDefId: data.processDefId,
                                processImg:'',
                                processVersionId: data.processVersionId,
                                qaList: data.qaList,
                                roleList: data.roleList,
                                serveName: data.serveName,
                                periordValidateHours : data.periordValidateHours ,
                                serveType: Number(data.serveType),
                                queryType: Number(data.queryType),
                                watchDeptId: (data.watchDept || {}).id || '',
                                hostFlag: data.hostFlag ? Number(data.hostFlag) : 0,
                            };
                            //回显移动平台 移动地址必填标识回显
                            if(!this.form.plateform.includes('2')){
                                this.rules.queryMobileUrl[0].required = false;
                            }else{
                                this.rules.queryMobileUrl[0].required = true;
                            }
                            this.userText= (data.checkUser || {}).userName || '';
                            this.roleSelect =(data.roleList||[]).map(i=>i.id+'');
                            let fileList=data.fileList
                            this.serveImgList=this.byFileTypeGetList(fileList,'0');
                            this.processImgList=this.byFileTypeGetList(fileList,'1');
                            this.onlineDescImgList=this.byFileTypeGetList(fileList,'3');
                            this.offlineDescImgList=this.byFileTypeGetList(fileList,'4');
                            break;
                    }

                });
            },
            saveOrUpdate(){
                this.loading = true;
                let params=JSON.parse(JSON.stringify(this.form));


                params={
                    ...params,
                    fileList:[...this.serveImgList,...this.processImgList,
                        ...this.onlineDescImgList,...this.offlineDescImgList],

                    offlineDesc: JSON.stringify(params.offlineDesc),
                    onlineDesc: JSON.stringify(params.onlineDesc),
                    policy: JSON.stringify(params.policy),
                    plateform: params.plateform.join(',')
                }
                delete params.serveCover;
                delete params.processImg;
                delete params.onlineDescImg;
                delete params.offlineDescImg;

                if(params.qaList&&params.qaList.length==1&&!params.qaList[0].answer&&!params.qaList[0].question){
                    params.qaList=[];
                }

                hallSaveOrUpdate(params).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0) {
                        this.$message.success(  "保存成功!" );
                        // this.show=false
                        this.close()
                        this.$emit('saveSuccess')

                    }else{
                        this.$message.warning(  data.msg||"保存失败!" );
                    }
                }).catch(err=>{
                    this.loading = false;
                    // this.$message.error(  "服务器异常!" );
                })
            },
            //显示人员选择
            addUser() {

                this.personData.state = true;
                this.$nextTick(()=>{
                    if(this.form.checkPersons){
                        this.personData.userData = [this.form.checkPersons];
                        this.personData.data = [{
                            userId: this.form.checkPersons,
                            name: this.userText
                        }];
                    }else{
                        this.personData.userData = [];
                        this.personData.data = [];
                    }

                    this.$refs.personModal.loadData();
                })
            },
            //选择人员
            closePerson(value) {
                if (!value.mans) {
                    this.personData.state = false;
                    return;
                }
                let mans=value.mans||[];
                this.userText= mans[0].name;
                this.form.checkPersons= mans[0].userId;
                this.personData.state = false;
            },
            // 确定提交
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.saveOrUpdate();
                    } else {
                        return false;
                    }
                });
            },
            close(){
                this.show = false
                this.fileList=[];
                this.form={
                    recommend:0,
                    applyCondition: "",
                    applyType: "",
                    attention: "",
                    plateform: [],
                    belongDeptId: "",
                    checkPersons: "",
                    serveCover:'',
                    contact: "",
                    contactMobile: "",
                    startRule:'',
                    fileList: [],
                    id: "",
                    intro: "",
                    offlineDesc: {
                        handleTime:'',
                        handleDesc :'',
                        feeWay :'',
                        place:'',
                        handleDegist :'',
                    },
                    onlineDesc: {
                        handleTime:'',
                        handleDesc :'',
                        feeWay :'',

                    },
                    offlineDescImg:'',
                    onlineDescImg:'',
                    processDefId: "",
                    processImg:'',
                    processVersionId: "",
                    policy:[],
                    qaList: [
                        {
                            answer: "",
                            id: "",
                            question: "",
                        }
                    ],
                    roleList: [
                        {
                            roleId: "",
                        }
                    ],
                    serveName: '',
                    periordValidateHours : '',
                    serveType: 0,
                    watchDeptId: '',
                    queryPcUrl: '',
                    queryMobileUrl: '',
                    queryType:'',
                    hostFlag: 0,
                };
                this.$refs["ruleForm"].resetFields();
            },
            byFileTypeGetList(arr,type){
                let list =arr.filter(i=>i.fileType == type)
                return list.map(i=>{
                    return {
                        ...i,
                        url:i.fileUrl,
                        id:i.fileId,
                        name:i.relatedFileName
                    }
                });
            },
            //可用平台chenge事件
            plateChange(arr){
                if(!arr.includes('2')){
                    this.rules.queryMobileUrl[0].required = false;
                }else{
                    this.rules.queryMobileUrl[0].required = true;
                }
                
                if(!arr.includes('1')){
                    this.rules.queryPcUrl[0].required = false;
                }else{
                    this.rules.queryPcUrl[0].required = true;
                }
            },
        },
        watch: {
            roleSelect(value){
                this.form.roleList=value.map(i=>{
                    return{roleId:i}
                })
            },
            serveImgList(value){
                this.form.serveCover = value.length?'true':'';

            },
            processImgList(value){
                this.form.processImg = value.length?'true':'';
            },
            offlineDescImgList(value){
                this.form.offlineDescImg = value.length?'true':'';
               },
            onlineDescImgList(value){
                this.form.onlineDescImg = value.length?'true':'';
            },
            show(value){
                if(!value){
                    this.serveList=[];
                }else{
                    // 打开弹框时，获取岗位和角色数据
                    this.getDeptTreeData()
                    this.getRoleListData()
                    this.getUserPage()
                }

            }
        },
        filters: {}
    };
</script>

<style scoped>
    .policy-list{
        border: 1px dashed #cccccc;
        border-radius: 5px;
        overflow: hidden;
        margin-bottom: 10px;
        background: #FFFFFF;
    }
    /deep/.quill-editor{
        height: auto!important;
    }
    /deep/.ql-container{
        min-height: 120px!important;
    }
    /deep/.ql-toolbar.ql-snow{
        padding: 0!important;
    }
    .info-content{
        height: calc(100vh - 150px);
        overflow: auto;
    }
    .area-item{
        background: #F5F5F5;
        padding: 10px 0;
        margin-bottom: 10px;
    }
    .area-title{
        height: 20px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #064576;
        line-height: 20px;
        margin-bottom: 10px;
        border-left: 3px solid #064576;
        padding-left: 15px;
    }
    .area-content{
        padding: 10px;
    }
    .img-warp{
        width: 48px;
        height: 48px;
    }
    .img-form{
        margin-bottom: 0!important;

    }
    .upload-demo .el-button{
        padding: 12px 12px!important;
    }
    .upload-demo .el-button .el-icon-upload{
        font-size: 22px;
    }
    .el-icon-delete{
        cursor: pointer;
        vertical-align: top;
        font-weight: bold;
        position: relative;
        right: 13px;
    }
    .el-icon-delete:hover{
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }

</style>
